<template>
  <div id="app">

    <!-- ❄️ CAPA DE NIEVE MÁGICA CON TAMAÑOS PROPORCIONADOS -->
    <div class="nieve-global-container" aria-hidden="true">
      <span class="copo-magico bola grande c1"></span>
      <span class="copo-magico cristal c2">❆</span>
      <span class="copo-magico bola mediana c3"></span>
      <span class="copo-magico bola chica c4"></span>
      <span class="copo-magico destello c5">✦</span>
      <span class="copo-magico bola mediana c6"></span>
      <span class="copo-magico cristal c7">❅</span>
      <span class="copo-magico bola chica c8"></span>
      <span class="copo-magico bola grande c9"></span>
      <span class="copo-magico destello c10">✧</span>
      <span class="copo-magico cristal c11">❄</span>
      <span class="copo-magico bola chica c12"></span>
      <span class="copo-magico bola mediana c13"></span>
      <span class="copo-magico destello c14">✦</span>
      <span class="copo-magico cristal c15">❆</span>
      <span class="copo-magico bola chica c16"></span>
      <span class="copo-magico bola grande c17"></span>
      <span class="copo-magico destello c18">✧</span>
    </div>

    <!-- 🔥 1. VIDEO -->
    <template v-if="pantalla === 'inicio'">
      <InicioLogo 
        v-if="isSmallScreen"
        @termino-video="irAPreguntar"
      />
      <PantallaG v-else />
    </template>

    <!-- 🔥 2. PREGUNTAR -->
    <template v-else-if="pantalla === 'preguntar'">
      <Preguntar 
        :id-invitado="idInvitado"
        :nombre="nombreFestejado"
        :id-festejado="idFestejado"
        @idioma-seleccionado="establecerIdioma" 
      />
    </template>

    <!-- 🔥 3. CONTENIDO -->
    <template v-else-if="pantalla === 'contenido'">

      <!-- ESPAÑOL -->
      <template v-if="idiomaSeleccionado === 'es'">
        <Componentep 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
          :id-festejado="idFestejado"
          :nombre="nombreFestejado"
        />
        <PantallaG v-else />
      </template>

      <!-- INGLÉS -->
      <template v-else-if="idiomaSeleccionado === 'en'">
        <ComponentePingles 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
          :id-festejado="idFestejado"
          :nombre="nombreFestejado"
        />
        <PantallaG v-else />
      </template>

    </template>

  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import InicioLogo from './components/inicio.vue'
import Preguntar from './components/preguntar.vue'
import Componentep from './components/contenedor.vue'
import ComponentePingles from './components/ingles/contenedor_ingles.vue'
import PantallaG from './components/pantallas_g.vue'

export default {
  components: {
    InicioLogo,
    Preguntar,
    Componentep,
    ComponentePingles,
    PantallaG,
  },
  setup() {
    const route = useRoute()

    // Extraemos los datos de la ruta URL
    const idInvitado = ref(Number(route.params.idInvitado) || undefined)
    const nombreFestejado = ref(route.params.nombre || route.params.nombreFestejado || '')
    const idFestejado = ref(Number(route.params.idFestejado) || undefined)

    const isSmallScreen = ref(window.innerWidth < 768)
    const pantalla = ref('preguntar') 
    const idiomaSeleccionado = ref(null)

    const irAPreguntar = () => {
      pantalla.value = 'preguntar'
    }

    const establecerIdioma = (idioma) => {
      idiomaSeleccionado.value = idioma
      pantalla.value = 'contenido'
    }

    // Escuchamos si cambian las variables en la URL
    watch(() => route.params, (newParams) => {
      idInvitado.value = Number(newParams.idInvitado) || undefined
      nombreFestejado.value = newParams.nombre || newParams.nombreFestejado || ''
      idFestejado.value = Number(newParams.idFestejado) || undefined
    }, { deep: true })

    window.addEventListener('resize', () => {
      isSmallScreen.value = window.innerWidth < 768
    })

    return {
      idInvitado,
      nombreFestejado,
      idFestejado,
      isSmallScreen,
      pantalla,
      idiomaSeleccionado,
      irAPreguntar,
      establecerIdioma,
    }
  }
}
</script>

<style scoped>
#app {
  position: relative;
  min-height: 100vh;
  width: 100%;
}

/* ❄️ CONTENEDOR DE NIEVE MÁGICA */
.nieve-global-container {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.copo-magico {
  position: absolute;
  top: -20px;
  animation: caidaNieveGlobal linear infinite;
  will-change: transform, opacity;
  display: inline-block;
}

/* ⚪ BOLITAS DE NIEVE BLANCAS Y DELICADAS (TAMAÑOS PEQUEÑOS Y ELEGANTES) */
.bola {
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.9), 0 0 10px rgba(135, 195, 255, 0.8);
}

.bola.chica { width: 5px; height: 5px; opacity: 0.9; }
.bola.mediana { width: 7px; height: 7px; opacity: 0.95; }
.bola.grande { width: 9px; height: 9px; opacity: 1; }

/* ❄️ CRISTALES Y COPOS DELICADOS */
.cristal {
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: bold;
  text-shadow: 0 0 6px #ffffff, 0 0 10px rgba(110, 180, 255, 0.8);
  opacity: 0.9;
}

/* ✨ DESTELLOS LUMINOSOS */
.destello {
  color: #ffffff;
  font-size: 0.8rem;
  text-shadow: 0 0 8px #ffffff, 0 0 12px rgba(120, 190, 255, 0.9);
  animation: caidaNieveGlobal linear infinite, parpadeo 1.8s ease-in-out infinite;
}

/* POSICIONES Y TIEMPOS DE CAÍDA */
.c1  { left: 5%;  animation-duration: 9s;   animation-delay: 0s; }
.c2  { left: 12%; animation-duration: 7s;   animation-delay: 1.2s; }
.c3  { left: 22%; animation-duration: 10s;  animation-delay: 3s; }
.c4  { left: 29%; animation-duration: 6s;   animation-delay: 0.5s; }
.c5  { left: 37%; animation-duration: 8s;   animation-delay: 2s; }
.c6  { left: 44%; animation-duration: 7.2s; animation-delay: 4.1s; }
.c7  { left: 52%; animation-duration: 9.5s; animation-delay: 0.8s; }
.c8  { left: 60%; animation-duration: 5.5s; animation-delay: 2.5s; }
.c9  { left: 67%; animation-duration: 8.8s; animation-delay: 0.3s; }
.c10 { left: 74%; animation-duration: 6.8s; animation-delay: 3.2s; }
.c11 { left: 81%; animation-duration: 10.2s;animation-delay: 1.8s; }
.c12 { left: 88%; animation-duration: 5.8s; animation-delay: 4.5s; }
.c13 { left: 95%; animation-duration: 8.2s; animation-delay: 0.6s; }
.c14 { left: 16%; animation-duration: 7.5s; animation-delay: 5s; }
.c15 { left: 39%; animation-duration: 9.2s; animation-delay: 3.5s; }
.c16 { left: 63%; animation-duration: 6.4s; animation-delay: 5.2s; }
.c17 { left: 84%; animation-duration: 9.8s; animation-delay: 2.8s; }
.c18 { left: 26%; animation-duration: 7.1s; animation-delay: 1.1s; }

/* ANIMACIÓN DE CAÍDA CON BALANCEO EN S */
@keyframes caidaNieveGlobal {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  50% {
    transform: translateY(50vh) translateX(18px) rotate(180deg);
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(105vh) translateX(-15px) rotate(360deg);
    opacity: 0;
  }
}

@keyframes parpadeo {
  0%, 100% { opacity: 0.6; transform: scale(0.85); }
  50% { opacity: 1; transform: scale(1.15); }
}
</style>